import { render } from "./JudgeAttendance.vue?vue&type=template&id=401eb16a"
import script from "./JudgeAttendance.vue?vue&type=script&lang=js"
export * from "./JudgeAttendance.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__